import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState, TListId } from '../../../types/types';
import { TStatus } from '../../../types/model';
import { listPatchRest } from './api/helpers/listPatchRest';

export const listSetName = (
    listId: TListId,
    name: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(listPatchRest(listId, {name}));
    };
    return action;
}
